import { useParams } from "react-router-dom";
import unidades from '../../core/unidades';
import './Unidade.css';
import { useEffect, useState } from "react";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";

const Unidade = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const { shortname } = useParams();
    const unidade = unidades.find(e => e.shortname === shortname);

    if (!unidade) {
        return <div>Unidade não encontrada</div>;
    }

    const photos = unidade.fotos;

    const openLightbox = (event, { photo, index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
    };

    return (
        <>
            <section id="unidade" class="mb-5">

                <div class="container">
                    <h2 class="title py-5">ADK {unidade.nome}</h2>

                    <p><span class="destaque">Endereço:</span> {unidade.endereco}</p>
                    <p><span class="destaque">Telefone:</span> {unidade.telefone} </p>
                    <p><span class="destaque">Horários de Treino:</span>
                        <ul>
                        {unidade.treinos.map(treino => (
                            <li key={`${treino.dia}-${treino.horario}`}>
                            {treino.dia}: {treino.horario}
                            </li>
                        ))}
                        </ul>
                    </p>
                </div>


                <div class="container">
                    <h2 class="title py-5">Galeria de Fotos</h2>
                    <Gallery photos={photos} onClick={openLightbox} />
                    <ModalGateway>
                        {viewerIsOpen ? (
                        <Modal onClose={closeLightbox}>
                            <Carousel
                            currentIndex={currentImage}
                            views={photos.map(x => ({
                                ...x,
                                srcset: x.srcSet,
                                caption: x.title
                            }))}
                            components={{
                                FooterCount: ({ currentIndex, views }) => (
                                  <div style={{ color: "#fff" }}>
                                    {`${currentIndex + 1} de ${views.length}`}
                                  </div>
                                )
                            }}
                            />
                        </Modal>
                        ) : null}
                    </ModalGateway>
                </div>

                <div class="container">
                    <h2 class="title py-5">Como chegar na ADK {unidade.nome}?</h2>
                    <iframe class="unidadeMaps" src={unidade.maps} allowfullscreen="false" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>

            </section>
        </>
    )
}


export default Unidade;
